export const ARTICLES_PART2 = [
  {
    slug: "ukhod-za-shuboy-sovety-masterov",
    title: "Как ухаживать за меховой шубой: советы итальянских мастеров",
    seoTitle: "Уход за шубой — как хранить и носить мех: советы | Angiolini",
    description:
      "Правила ухода за меховой шубой: как носить, сушить и хранить мех, чего избегать, когда нужна профессиональная чистка — рекомендации итальянских скорняков Angiolini.",
    date: "2026-06-17",
    readTime: "5 мин",
    tag: "Уход",
    image: "/media/frame-5.jpg",
    sections: [
      {
        h: "Повседневные правила",
        ps: [
          "Мех не любит трения: откажитесь от сумок на плечо и рюкзаков, следите, чтобы ремень безопасности в автомобиле не проходил по одному и тому же месту. Избегайте парфюма и лака для волос на ворсе — спирт разрушает естественную смазку волоса.",
          "Попали под снег или дождь — не страшно. Встряхните шубу и просушите её на широких плечиках при комнатной температуре, вдали от батарей и обогревателей. Фен и сушилки запрещены: горячий воздух пересушивает мездру.",
        ],
      },
      {
        h: "Хранение между сезонами",
        ps: [
          "Идеальные условия для меха: температура +2…+8 °C и влажность около 50%. Летом шубу лучше отдавать в специализированное меховое хранилище — в шкафу городской квартиры мех страдает от тепла и сухости.",
          "Если храните дома, используйте дышащий тканевый чехол (никакого полиэтилена), широкие плечики по размеру и свободное пространство вокруг: мех не должен быть смят соседними вещами.",
        ],
      },
      {
        h: "Профессиональный уход",
        ps: [
          "Раз в один-два сезона показывайте шубу скорняку: мастер освежит ворс, проверит швы и подкладку, устранит мелкие потёртости до того, как они станут проблемой.",
          "Клиенты Angiolini получают рекомендации по уходу и сезонное обслуживание в наших ателье — записаться можно через приложение в пару касаний.",
        ],
      },
    ],
  },
  {
    slug: "milan-stolitsa-modi-vernyaya-odezhda",
    title: "Милан — столица моды: чем живёт родина лучшей верхней одежды",
    seoTitle: "Милан — столица моды и итальянской верхней одежды | Angiolini",
    description:
      "Почему Милан считается мировой столицей моды: недели моды, кварталы ателье, меховые дома и то, как миланский стиль формирует моду на верхнюю одежду во всём мире.",
    date: "2026-06-20",
    readTime: "6 мин",
    tag: "Италия",
    image: "/media/frame-1.jpg",
    sections: [
      {
        h: "Город, где рождается стиль",
        ps: [
          "Милан — это не только неделя моды и «золотой квадрат» бутиков Монтенаполеоне. Настоящая мода рождается в кварталах ателье, где семейные мастерские десятилетиями шьют для главных домов планеты.",
          "Именно в Милане сформировалась знаменитая итальянская школа верхней одежды: строгий силуэт, безупречная посадка и внимание к тактильности — вещь должна быть приятной не только глазу, но и руке.",
        ],
      },
      {
        h: "Меховые дома Милана",
        ps: [
          "Миланские скорняки первыми начали относиться к меху как к кутюру: соболь и норка в их руках превращаются в архитектурные силуэты, а не просто в тёплую одежду. Многие техники — расшивка «в роспуск», градиентная сборка шкурок — родились именно здесь.",
          "Каждый сезон дома Милана задают меховую моду: оттенки, длину, форму воротников. Всё, что вы увидите в мировых бутиках через год, сначала показывают в миланских шоурумах.",
        ],
      },
      {
        h: "Милан ближе, чем кажется",
        ps: [
          "Angiolini отбирает коллекции напрямую в миланских ателье и привозит их в Алматы. Новые поступления появляются в приложении раньше, чем в социальных сетях, — участники клуба видят их первыми.",
          "Откройте приложение Angiolini и следите за новинками из Милана, не выходя из дома.",
        ],
      },
    ],
  },
  {
    slug: "kak-otlichit-italyanskiy-mekh",
    title: "Как отличить настоящий итальянский мех от подделки",
    seoTitle: "Как отличить итальянский мех от подделки: 7 признаков | Angiolini",
    description:
      "Семь признаков настоящей итальянской шубы: маркировка, качество швов, мездра, фурнитура и документы. Чек-лист покупателя от экспертов Angiolini.",
    date: "2026-06-23",
    readTime: "6 мин",
    tag: "Экспертиза",
    image: "/media/frame-4.jpg",
    sections: [
      {
        h: "Документы и маркировка",
        ps: [
          "Настоящая итальянская шуба всегда сопровождается документами: сертификатом происхождения меха, составом изделия и данными производителя. Ярлык «Made in Italy» защищён законом — подделка маркировки в Италии уголовно наказуема.",
          "Проверьте внутренние ярлыки: у оригинала они вшиты в шов, текст читается чётко, а бренд совпадает с документами. Приклеенные или свободно висящие ярлыки — тревожный знак.",
        ],
      },
      {
        h: "Что расскажут швы и мездра",
        ps: [
          "Выверните изделие: у итальянской работы швы тонкие, ровные, без пропусков, а шкурки подобраны так, что рисунок меха непрерывен. Грубые стыки и «ступеньки» в окрасе выдают кустарный пошив.",
          "Мездра должна быть светлой и эластичной. Пощупайте шубу на весу: качественная выделка делает изделие удивительно лёгким для своего объёма.",
        ],
      },
      {
        h: "Фурнитура и посадка",
        ps: [
          "Итальянские дома не экономят на мелочах: крючки и застёжки с гравировкой, шёлковая подкладка, обработанные вручную края. Пластиковая фурнитура без маркировки на «итальянской» шубе — почти гарантия подделки.",
          "И главное — посадка. Итальянская шуба садится по фигуре сразу: плечо на месте, воротник обнимает шею, подол падает ровно. Все шубы Angiolini проходят финальную подгонку в нашем ателье, а подлинность подтверждается документами.",
        ],
      },
    ],
  },
  {
    slug: "italyanskaya-verkhnyaya-odezhda-almaty",
    title: "Итальянская верхняя одежда в Алматы: где искать и как выбирать",
    seoTitle: "Итальянская верхняя одежда в Алматы — шубы и пальто | Angiolini",
    description:
      "Где купить итальянскую верхнюю одежду в Алматы: шубы из соболя и норки, кашемировые пальто, пуховики. Каталог, цены и примерка в бутике Angiolini в Нурлы Тау.",
    date: "2026-06-26",
    readTime: "5 мин",
    tag: "Алматы",
    image: "/media/poster.jpg",
    sections: [
      {
        h: "Итальянское качество в Казахстане",
        ps: [
          "Ещё недавно за настоящей итальянской шубой приходилось лететь в Милан. Сегодня коллекции итальянских домов доступны в Алматы: Angiolini привозит верхнюю одежду напрямую из ателье Италии — без посредников и наценок перекупщиков.",
          "В коллекции — шубы из соболя, норки и шиншиллы, кашемировые пальто, премиальные пуховики и новые итальянские бренды, которые только выходят на рынок Казахстана.",
        ],
      },
      {
        h: "Бутик в Нурлы Тау",
        ps: [
          "Шоурум Angiolini находится в деловом центре Нурлы Тау в Алматы. Здесь можно примерить модели из каталога, получить консультацию стилиста и подогнать выбранную вещь по фигуре у мастера.",
          "Перед визитом изучите каталог в приложении: выберите модели заранее, запишитесь на удобное время — и мы подготовим всё к вашему приезду.",
        ],
      },
      {
        h: "Начните с приложения",
        ps: [
          "В приложении Angiolini собран весь каталог с актуальными ценами и размерами, работает виртуальная ИИ-примерка, а за регистрацию начисляются приветственные бонусы, которые можно потратить на покупку.",
          "Регистрация занимает меньше минуты и не требует скачивания — приложение открывается прямо в браузере телефона.",
        ],
      },
    ],
  },
  {
    slug: "mekhovaya-moda-2026-trendy-italii",
    title: "Меховая мода 2026: главные тренды из Италии",
    seoTitle: "Меховая мода 2026 — тренды итальянских домов | Angiolini",
    description:
      "Тренды меховой моды 2026 года: актуальные силуэты, оттенки и фактуры от итальянских домов. Какие шубы носить в новом сезоне — обзор Angiolini.",
    date: "2026-06-29",
    readTime: "6 мин",
    tag: "Тренды",
    image: "/media/frame-2.jpg",
    sections: [
      {
        h: "Силуэты сезона",
        ps: [
          "Главная идея 2026 года — расслабленная роскошь. Итальянские дома показывают шубы-халаты с мягким поясом, объёмные модели до колена и укороченные жакеты, которые носят с денимом и вечерними платьями одинаково легко.",
          "Возвращаются высокие воротники-стойки и рукава три четверти — под длинные перчатки. Приталенные силуэты уходят на второй план, уступая место свободному крою.",
        ],
      },
      {
        h: "Цвета и фактуры",
        ps: [
          "Палитра сезона — природная: топлёное молоко, орех, графит, глубокий шоколад. Итальянцы почти отказались от яркого окрашивания в пользу естественной красоты меха с его переливами и градиентами.",
          "В фаворитах — стриженая норка с эффектом бархата, соболь в роспуск и комбинации меха с кашемиром: воротники и манжеты из шиншиллы на кашемировых пальто стали визитной карточкой сезона.",
        ],
      },
      {
        h: "Где смотреть тренды",
        ps: [
          "Коллекция Angiolini 2026 года уже отражает главные идеи миланских показов: свободные силуэты, природные оттенки, комбинированные фактуры. Новинки появляются в приложении раньше, чем где-либо ещё.",
          "Откройте каталог, сохраняйте понравившиеся модели и записывайтесь на примерку — сезон обещает быть красивым.",
        ],
      },
    ],
  },
];
